import { render, staticRenderFns } from "./goods-list.vue?vue&type=template&id=6f0cb6b3&scoped=true"
import script from "./goods-list.vue?vue&type=script&lang=js"
export * from "./goods-list.vue?vue&type=script&lang=js"
import style0 from "./goods-list.vue?vue&type=style&index=0&id=6f0cb6b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0cb6b3",
  null
  
)

export default component.exports